'use client';

import { TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { ErrorBoundary, LegacyIcon, LegacyIconName } from '@libs/common-next';

import { Loading, LoggedIn, SignIn } from './components';
import { useAccountDropdown } from './use-account-dropdown';
import './LegacyAccountDropdown.scss';

export function LegacyAccountDropdown() {
    const { isLoading, isLoggedIn } = useAccountDropdown();

    const accountAction = isLoading ? (
        <>
            <div className="legacy-account__title">
                <Loading />
            </div>
            <TextPassage className="legacy-account__sub">Rewards &amp; Account</TextPassage>
        </>
    ) : isLoggedIn ? (
        <>
            <div className="legacy-account__title">
                <LoggedIn />
            </div>
            <TextPassage className="legacy-account__sub">Rewards &amp; Account</TextPassage>
        </>
    ) : (
        <>
            <div className="legacy-account__title">
                <ErrorBoundary>
                    <SignIn />
                </ErrorBoundary>
            </div>
            <TextPassage className="legacy-account__sub">Rewards &amp; Account</TextPassage>
        </>
    );

    return (
        <div className={cn('legacy-account')}>
            <div className={cn('legacy-account__inner')}>
                <div className="legacy-account__icon-box">
                    <LegacyIcon isPriority size={45} className="icon" name={LegacyIconName.TREATS_NEW_LG} />
                </div>

                <div className="legacy-account__action">{accountAction}</div>
            </div>
        </div>
    );
}
